export enum SearchResultGroupType {
  NetworkElement = 1,
  Measurement = 2,
  AttributeResult = 3
}
